import { ProductConfiguration } from '../../shared/models/product';

import { FormEorder } from './form-eorder';
import { Eorder, ProductFamily, TemplateDescription } from './eorder';

export enum EorderWizardStep {
	ORDERINFORMATION = 0, PRODUCTMODIFICATION = 1, SUMMARY = 2, CONFIRMATION = 3
}

class WizardStateEorder {
	readonly form = new FormEorder();

	constructor(order: Eorder) {
		this.form = new FormEorder();
		this.form.setEorder(order);
	}
}

class AppWizardStateUi {
	private readonly productFamilies: Record<string, ProductFamily[]> = {};
	private lastSelectedProductFamily: ProductFamily | undefined;
	private readonly templateNumberDetails = new Map<number, TemplateDescription>();
	private readonly configurationData = new Map<string, ProductConfiguration>();
	private lastSelectedSoldTo: string | undefined;
	getProductFamilies(soldTo: string) {
		const code = soldTo;
		if (code in this.productFamilies) {
			return this.productFamilies[code];
		}
		return undefined;
	}

	setProductFamilies(soldTo: string, productFamilies: ProductFamily[]) {
		this.productFamilies[soldTo] = productFamilies;
	}

	setSoldTo(soldTo: string) {
		this.lastSelectedSoldTo = soldTo;
	}

	getLastSelectedSoldTo() {
		return this.lastSelectedSoldTo;
	}

	getSelectedProductFamily() {
		return this.lastSelectedProductFamily;
	}

	getSelectedProductFamilyDescription() {
		return this.lastSelectedProductFamily ? this.lastSelectedProductFamily.subCategoryDescription : '';
	}

	setSelectedProductFamily(productFamily: ProductFamily | undefined) {
		this.lastSelectedProductFamily = productFamily;
	}

	hasTemlpateDetail(templateNumber: number) {
		return this.templateNumberDetails.has(templateNumber);
	}

	updateTemplateNumberDetails(templateNumber: number, templateDescription: TemplateDescription) {
		this.templateNumberDetails.set(templateNumber, templateDescription);
	}

	getTemplateNumberDetails(templateNumber: number) {
		return this.templateNumberDetails.get(templateNumber);
	}

	updateConfigurationData(configurationNumber: string, product: ProductConfiguration) {
		this.configurationData.set(configurationNumber, product);
	}

	getConfigurationData(configurationNumber: string) {
		return this.configurationData.get(configurationNumber);
	}

	hasConfigurationData(configurationNumber: string) {
		return this.configurationData.has(configurationNumber);
	}
}

export class EorderWizardState {
	stepIndex: EorderWizardStep = EorderWizardStep.ORDERINFORMATION;
	isValid = false;
	exiting = false;
	errorInPage = false;
	readonly scrollPositionByStep = [0, 0, 0, 0, 0];
	readonly order: WizardStateEorder;
	readonly ui: AppWizardStateUi;
	constructor(order: Eorder) {
		this.order = new WizardStateEorder(order);
		this.ui = new AppWizardStateUi();
	}
}
